import styled from 'styled-components';
import {
  InsurerStyled,
  InsurerStyledHeader,
  InsurerStyledHeaderSide,
  InsurerStyledHeaderTitle,
  PaymentMethodsBody,
  PaymentMethodsStyledTitle,
} from 'app/Components/common/Insurer/styles';

export const CepikSettingsStyled = styled.div``;

export const CepikInsurerRow = styled(InsurerStyled)``;

export const CepikInsurerHeader = styled(InsurerStyledHeader)``;

export const CepikInsurerSide = styled(InsurerStyledHeaderSide)`
    &:not(:last-child) {
        border-right: 0;
    }
`;

export const CepikInsurerTitle = styled(InsurerStyledHeaderTitle)``;

export const CepikToggleBody = styled(PaymentMethodsBody)`
    padding-left: 4px;
`;

export const CepikToggleLabel = styled(PaymentMethodsStyledTitle)`
  margin-left: 0;
`;

export const CepikControlsStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
`;

export const CepikInfoBlock = styled.div`
  padding: 12px 16px;
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.colors.sidebarBg};
  border-left: 3px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius};
  font-family: ${({ theme }) => theme.text.normal['font-family']};
  font-size: ${({ theme }) => theme.text.normal['font-size']};
  color: ${({ theme }) => theme.colors.text};
`;
